import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import filter from '../../components/ui-components/filter/filter.vue'
import onScrollAnimate from '@assets/js/scrollAnimate.js'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
    }
  },
  components: {
    'filter-cmp': filter,
  },
  methods: {},
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')
    this.$root.setDataAnimateFalse()

    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next()
        setTimeout(() => {
          this.template = data.data
          onScrollAnimate()
        }, 500)
      },
      () => {
        next('/404')
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/archive-promotions/index.js